import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import DepartmentDetails from './DepartmentDetails';
import DepartmentsList from './DepartmentsList';
import { translate } from 'components/Translation';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';

interface IDepartmentsPageProps {
	match: {
		url: string;
		path: string;
	};
	account: {
		accountName: string;
	};
}

const Departments = (props: IDepartmentsPageProps) => {
	const { match, account } = props;
	return (
		<div>
			<ConditionalRender
				show={!!account}
				onTrue={() => (
					<BreadcrumbsItem to={props.match.url}>
						{`${account.accountName} - ${translate('path.departments')}`}
					</BreadcrumbsItem>
				)}
			/>
			<Switch>
				<Route
					path={`${match.path}/details/:departmentId([0-9][0-9]*)?`}
					render={(props: any) => <DepartmentDetails {...props} />}
				/>
				<Route
					path={match.path}
					exact
					render={(props: any) => <DepartmentsList account={account} {...props} />}
				/>
			</Switch>
		</div>
	);
};

export default Departments;
